import * as React from 'react';
import { Box, Stack, Typography, Grid } from '@mui/material';
import { settingActions, settingObj } from '../store/SettingSlice';
import { useSelector, useDispatch } from 'react-redux';
import { json, useNavigate } from "react-router-dom";
import * as JSTool from '../store/JSTool';

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/effect-fade';
import { Autoplay, EffectFade } from 'swiper/modules';

import TitleView from '../component/TitleView';

export default function Page5_m(props) {

    const [swp, setSwp] = React.useState(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const settingData = useSelector(state => state.settingData);

    React.useEffect(() => {

    }, []);


    function leftTap() {
        if (swp) {
            swp.slidePrev();
        }
    }

    function rightTap() {
        if (swp) {
            swp.slideNext();
        }
    }

    function indexChanged() {

    }

    return (
        <Stack
            id={props.anchorId}
            sx={{
                width: 1,
                height: settingData.innerHeight,
                alignItems: 'center',
                position: 'relative',
            }}>

            <Box
                component={'img'}
                src={JSTool.getImgPath('bg/bg_5.png')}
                sx={{
                    width: 1,
                    height: settingData.innerHeight,
                    objectFit: 'cover',
                    zIndex: 1,
                    position: 'absolute',
                }} />

            <Stack sx={{
                height: settingData.innerHeight,
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 2,
            }}>

                <TitleView title='Summons' mt={'50rem'} />

                <Grid container
                    sx={{
                        width: 1,
                        zIndex: 10,
                        mt:2,
                        ml:3,
                    }}>
                    {[0, 1, 2, 3, 4, 5].map((item, index) => {
                        return <Grid key={index} item xs={4}> <Item item={JSTool.RoleAry[index]} index={index} /> </Grid>
                    })}
                </Grid>

            </Stack>
        </Stack>
    );
}

function Item(props) {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    function itemTap() {
        dispatch(settingActions.setRoleItem(props.item));
        navigate('/role_detail');
    }

    return (
        <Stack
            onClick={itemTap}
            sx={{
                position: 'relative',
                cursor: 'pointer',
            }}>
            <Box component={'img'}
                src={JSTool.getImgPath(`stellars/${props.item.name}_big.png`)}
                sx={{
                    width: '140rem',
                    mt:  0,
                    filter: 'drop-shadow(0px 0px 15px #745ff299)',
                }} />

            <Box component={'img'}
                src={JSTool.getImgPath(`stellars/${props.item.name}_icon.png`)}
                sx={{
                    position: 'absolute',
                    width: '35rem',
                    bottom: '28rem',
                    left: '13rem'
                }} />

            <Box
                component={'div'}
                sx={{
                    position: 'absolute',
                    color: 'white',
                    fontSize: '15rem',
                    fontWeight: 'bold',
                    bottom: '38rem',
                    left: '55rem',
                    fontFamily: window.font0,
                    transform: 'skewY(-10deg)',
                }}
                dangerouslySetInnerHTML={{
                    __html:
                        `${JSTool.capitalize(props.item.name)}<br/>${props.item.nick}`,
                }} />

        </Stack>
    );
}
